// Hesaba Virman (aynı bankanın ana / alt hesapları arası) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.accountTransfer';

export const bankAccountTransferGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Hesaba virman nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Virman, aynı bankadaki ana hesap ile alt hesapları arasında para aktarmaktır (ör. vadesiz hesaptan POS alt hesabına). Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Hesaba Virman'),
    body: t(`${G}.regions.body`, 'Banka, hesaplar ve tutar'),
    footer: t(`${G}.regions.footer`, 'Transfer Yap'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Bankayı seçin'),
      text: t(`${G}.s1.text`, 'Banka listesinde yalnız alt hesabı olan banka hesapları görünür; ilki kendiliğinden seçilir. Liste boşsa ("Alt hesabı olan banka bulunamadı") önce Banka sayfasında bir alt hesap ekleyin.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kaynak ve hedef hesabı seçin'),
      text: t(`${G}.s2.text`, 'Kaynak Hesap paranın çıkacağı, Hedef Hesap gireceği hesaptır. İkisinde de bankanın Ana Hesabı ve alt hesapları seçilebilir; aynı hesap iki tarafa birden seçilemez. Ortadaki ⇄ düğmesi yönü tersine çevirir.'),
      tips: [
        t(`${G}.s2.tip1`, 'İki hesabın para birimi aynı olmalıdır; farklıysa kırmızı uyarı çıkar ve transfer yapılamaz.'),
        t(`${G}.s2.tip2`, 'Alttaki kutular iki hesabın mevcut bakiyesini gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Tutar ve belge bilgisi'),
      text: t(`${G}.s3.text`, 'Transfer Miktarı zorunludur; kuruşu nokta ile yazın (ör. 1500.50). Kaynak hesabın bakiyesinden fazla tutar girilirse "Transfer Yap" pasif kalır. Belge/Dekont No ve Açıklama isteğe bağlıdır.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Transferi tamamlayın'),
      text: t(`${G}.s4.text`, '"Transfer Yap" ile tutar kaynak hesaptan düşülür ve hedef hesaba eklenir; iki hesapta da "Virman" hareketi oluşur. İki kayıt birlikte işlenir: biri başarısız olursa hiçbiri yapılmaz. Başarı mesajından sonra pencere kendiliğinden kapanır.'),
      tips: [
        t(`${G}.s4.tip1`, 'Virman, bankanın toplam parasını değiştirmez; yalnız hesaplar arasındaki dağılımı değiştirir.'),
        t(`${G}.s4.tip2`, 'Hatalı virmanı düzeltmek için ⇄ ile yönü çevirip aynı tutarı geri aktarın.'),
      ],
    },
  ],
});
